import { render, staticRenderFns } from "./ResourceComponent.vue?vue&type=template&id=da0b9dbc&"
import script from "./ResourceComponent.vue?vue&type=script&lang=js&"
export * from "./ResourceComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports